import React, { useEffect } from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getDefaultName, userAvatar } from '../../../../utils';
import { ApiHttpService } from '../../../../utils/http/api';
import { loadNewestCourse } from '../../../../utils/Network';

export default function WidgetContestReport() {
    const [course_summary, setCourseSummary] = useState(null);
    const [loading, setLoading] = useState(20);
    const [course, setCourse] = useState(null);

    useEffect(() => {
        _getData();
    }, []);

    const _getData = () => {

        setLoading(true)
        loadNewestCourse().then(course => {
            if (course) {
                setCourse(course)
                ApiHttpService.loadCourseSummary(course.id).then(data => {
                    setCourseSummary(data)
                    setLoading(false)
                })
            }
        })

    }

    return (
        <div className="box box-solid bg-dark">
            <div className="box-header no-bg">
                <Link to={`contest/${course && course.id}`}>
                    <h3 className="box-title color-dark ">{course && getDefaultName(course.names)}
                    &nbsp;<small>{course && course.startdate} - {course && course.enddate}</small>

                    </h3>
                </Link>

                <div className="box-tools pull-right">
                    <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i>
                    </button>
                    <button type="button" className="btn btn-box-tool" data-widget="remove"><i className="fa fa-times"></i></button>
                </div>
            </div>
            <div className="box-body padding-15">
                <table className='table table-statistics'>
                    <tr>
                        <td>Participants:</td>
                        <td>{course_summary && course_summary.number_of_participants.toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td>Cities:</td>
                        <td>{course_summary && course_summary.number_of_cities}</td>
                    </tr>
                    <tr>
                        <td>Juries:</td>
                        <td>{course_summary && course_summary.number_of_juries}</td>
                    </tr>
                    <tr>
                        <td>Public votes:</td>
                        <td>{course_summary && course_summary.number_of_public_votes.toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td>Poll votes:</td>
                        <td>{course_summary && course_summary.number_of_poll_votes.toLocaleString()}</td>
                    </tr>
                </table>
            </div>
        </div>
    )
}
